import {module} from 'modujs';
import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
gsap.registerPlugin(DrawSVGPlugin);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const path = this.el.querySelectorAll('path')
        const args = this.getData('repeat-delay') !== null ? {repeat:-1, repeatDelay:parseInt(this.getData('repeat-delay'))} : ""

        this.tl = gsap.timeline(args)
        this.tl.fromTo(path, { drawSVG: '0% 0%' }, { duration: this.getData('duration'), drawSVG: '0% 100%', ease: 'power4.out' })

        if (this.getData('revert-delay') !== null) {
            this.tl.to(path,{ duration: 0.6*this.getData('duration'), drawSVG: '100% 100%', ease: 'power2.in' }, '+='+this.getData('revert-delay'))
        }
    }
}
